import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from "@mui/material";
import produce from "immer";
import { omit } from "lodash";
import * as React from "react";
import RestForm from "./RestForm";
import TeethMarkerComponent, { Legend, TeethData, legendMapId } from "./TeethMarkerComponent";

export interface IntraOralAdvancedData {
  teethData: Array<TeethData>;
  softTissueExamination: string;
  occlusion: string;
  calculus: string;
  stain: string;
  cariesRisk: string;
  recallGap: string;
  attrition: string;
  abrasion: string;
  erosion: string;
  abfraction: string;
  bpe: Array<string>;
}

interface Props {
  open: boolean;
  handleClose: () => void;
  data: IntraOralAdvancedData;
  onChange: (v: IntraOralAdvancedData) => void;
  onCancel: () => void;
}

export default function IntraOralAdvancedForm(props: Props): React.JSX.Element {
  const { open, handleClose, data, onChange, onCancel } = props;
  const [activeItem, setActiveItem] = React.useState<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    part: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    item: any;
    index: number;
  }>({ part: null, item: null, index: null });

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullScreen
      slotProps={{
        paper: {
          sx: { borderRadius: 0 }
        }
      }}
    >
      <DialogTitle id="alert-dialog-title">Advanced Intra Oral Examination</DialogTitle>
      <DialogContent sx={{ p: 0, overflowY: "auto", overflowX: "hidden" }}>
        <Box
          sx={{
            overflowX: "auto",
            overflowY: "hidden",
            WebkitOverflowScrolling: "touch",
            borderBottom: "1px solid",
            borderColor: "divider"
          }}
        >
          <Box sx={{ minWidth: "600px", p: { xs: 1.5, sm: 2 } }}>
            <TeethMarkerComponent
              teethData={data.teethData}
              hideLegend
              onActiveItemChange={setActiveItem}
              onChange={(teeth) => {
                const updatedState = produce(data, (draft) => {
                  draft.teethData = teeth;
                });
                onChange(updatedState);
              }}
            />
          </Box>
        </Box>

        <Box sx={{ p: { xs: 2, sm: 3 } }}>
          <Legend
            item={activeItem.item}
            updateActiveItem={(legendId) => {
              if (activeItem.index === null) return;
              const updatedState = produce(data.teethData, (draft) => {
                draft[activeItem.index].tooth.v[activeItem.part] = {
                  legendId,
                  legendName: legendMapId[legendId]
                };
                draft[activeItem.index].shapeState[activeItem.part].isActive = false;
              });
              onChange({ ...data, teethData: updatedState });
              setActiveItem({ part: null, item: null, index: null });
            }}
          />
        </Box>

        <Box sx={{ p: { xs: 2, sm: 3 } }}>
          <RestForm
            data={omit(data, ["teethData"])}
            onChange={(v) => onChange({ ...data, ...v })}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            onCancel();
            handleClose();
          }}
        >
          Cancel / Clear
        </Button>
        <Button onClick={handleClose} variant="contained">
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
}
